export const hotelRoomAmenities = {
  bathtub: "Bathtub",
};
